function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 170.51,
  y1: 103.77,
  x2: 205.81,
  y2: 388.4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 226.33,
  y1: 280.91,
  x2: 224.92,
  y2: 228.82,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 202.61,
  y1: 72.94,
  x2: 110.36,
  y2: 131.04,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 197.85,
  y1: 79.71,
  x2: 127.35,
  y2: 124.11,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: 159.09,
  y1: 137.11,
  x2: 158.78,
  y2: 123.36,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: 227.03,
  y1: 237.99,
  x2: 226.55,
  y2: 294.8,
  xlinkHref: "#linear-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 71.09,
  y: 32.9,
  width: 316.78,
  height: 223.86,
  rx: 13.42,
  fill: "#33c1ea"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 81.88,
  y: 40.51,
  width: 295.27,
  height: 205.46,
  rx: 12.41,
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  points: "267.49 221.56 221.03 198.33 72.03 198.33 72.03 144.69 285.8 144.69 266.79 183.08 267.49 221.56",
  fill: "url(#linear-gradient)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M287.79,91.67V196.38A13.83,13.83,0,0,1,274,210.21H60.85a13.8,13.8,0,0,1-13.8-13.83V91.67a13.8,13.8,0,0,1,13.8-13.8H274A13.82,13.82,0,0,1,287.79,91.67Z",
  transform: "translate(-1.99 -24.55)",
  fill: "#33c1ea"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M167.21,104.72a2.55,2.55,0,0,1-3.23-1.45l-2.42-6.43a7.18,7.18,0,0,0-13.43,5.08l3.35,8.85a2.5,2.5,0,0,1,.12.45h-5.3l-2.85-7.53a12.18,12.18,0,0,1,22.78-8.62l2.43,6.42A2.5,2.5,0,0,1,167.21,104.72Z",
  transform: "translate(-1.99 -24.55)",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 45.75,
  y: 254.65,
  width: 360.42,
  height: 25.34,
  rx: 12.02,
  fill: "#33c1ea"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 45.75,
  y: 254.65,
  width: 360.42,
  height: 25.34,
  rx: 12.02,
  fill: "url(#linear-gradient-2)"
});

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  points: "225.25 184.96 267.49 221.56 267.49 176.86 225.25 184.96",
  fill: "#33c1ea"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 76.25,
  y: 127.7,
  width: 175.52,
  height: 30.04,
  rx: 6.19,
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 140.19,
  y: 86.73,
  width: 32.85,
  height: 30.35,
  fill: "url(#linear-gradient-3)"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 152.4,
  y: 86.67,
  width: 20.6,
  height: 30.35,
  fill: "url(#linear-gradient-4)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M157.82,125.44s-3.24-2.7-.41-5,6,2.5,3,5l2.11,5.63H155.4Z",
  transform: "translate(-1.99 -24.55)",
  fill: "url(#linear-gradient-5)"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 101.38,
  cy: 142.02,
  r: 6.27
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 118.29,
  cy: 142.02,
  r: 6.27
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 135.2,
  cy: 142.02,
  r: 6.27
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 152.11,
  cy: 142.02,
  r: 6.27
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 170.35,
  cy: 142.02,
  r: 6.27
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 187.26,
  cy: 142.02,
  r: 6.27
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 204.17,
  cy: 142.02,
  r: 6.27
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 221.09,
  cy: 142.02,
  r: 6.27
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M55.48,68.08a5,5,0,0,1-4.58-3L40.1,40.2a5,5,0,1,1,9.18-4L60.07,61.09a5,5,0,0,1-4.59,7Z",
  transform: "translate(-1.99 -24.55)",
  fill: "#33c1ea"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M7,102.19a5,5,0,0,1-.33-10l27.05-1.81a5,5,0,1,1,.67,10L7.33,102.18Z",
  transform: "translate(-1.99 -24.55)",
  fill: "#33c1ea"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M35.77,77.58A4.94,4.94,0,0,1,33,76.72L10.53,61.48a5,5,0,0,1,5.62-8.27L38.58,68.45a5,5,0,0,1-2.81,9.13Z",
  transform: "translate(-1.99 -24.55)",
  fill: "#33c1ea"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 190.29,
  y: 254.88,
  width: 73.12,
  height: 7.51,
  fill: "url(#linear-gradient-6)"
});

function SvgForgotPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 421.26 322.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Password") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M396,113.25c-17.19-19.53-39.22-34.06-61-48.35-26.33-17.3-53.81-35.05-85-39.34-29.79-4.1-60.21,4.68-86.61,19.09S114,78.86,91.21,98.5L37.58,144.76c-11.28,9.73-22.88,19.86-29.3,33.3-5.45,11.4-6.74,24.44-5.7,37a107.94,107.94,0,0,0,39.05,74C57.21,301.69,76,309.66,94.69,317c34.34,13.44,69.74,25.3,106.47,28.6,39.22,3.53,78.58-2.82,117.44-9.15,47.72-7.77,75.1-28.06,83-75.07,4.29-25.44,18.2-48.49,21.12-74C425.89,159.91,413.77,133.48,396,113.25Z",
    transform: "translate(-1.99 -24.55)",
    fill: "#33c1ea",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPassword);
export default __webpack_public_path__ + "static/media/forgot_password.32cadafc.svg";
export { ForwardRef as ReactComponent };